import { useNavigate } from "react-router-dom"
import { useState }from 'react'
import imagen from 'assets/images/home.jpg';

function Header(){

    const navigate = useNavigate()
    
    const [searchData, setSearchData] = useState({
      evento: "",
      ciudad: "",
      fecha: "",
    });
  
    const onChange = e => setSearchData({
      ...searchData,
      [e.target.name]: e.target.value
    });

    const onSubmit = (e) => {
        e.preventDefault();
        const queryParams = new URLSearchParams(searchData).toString();
        navigate(`/eventos?${queryParams}`);
    };
  
    
    return (
      
        <div className="relative flex-1 bg-cover bg-bottom" style={{ backgroundImage: `url(${imagen})` }}>
          <div className="absolute inset-0 bg-gradient-to-b from-black via-transparent/40 to-white" />

          <div className="absolute inset-0 max-w-3xl mx-auto mt-0 md:mt-20">
            <div className="py-10 text-white px-5">
              <h1 className="text-6xl md:text-7xl font-semibold mb-5">Encuentra tu evento</h1>
              <p className="text-2xl md:text-3xl">Conecta con personas y comparte transporte</p>
            </div>
            <form onSubmit={(e) => onSubmit(e)} className="hidden md:inline-flex rounded-3xl md:gap-x-4 bg-white px-10 py-5 shadow-2xl">

              <input
                  id='evento'
                  name='evento'
                  placeholder="Artista, evento o recinto"
                  value={searchData.evento}
                  onChange={(e)=>onChange(e)}
                  type='text'
                  className="rounded-3xl"
              />

              <select
                  id='ciudad'
                  name='ciudad'
                  placeholder="ciudad"
                  value={searchData.ciudad}
                  onChange={(e)=>onChange(e)}
                  className="rounded-3xl"
              >
                        <option value="">Seleccionar ciudad</option>
                        <option value="madrid">Madrid</option>
                        <option value="barcelona">Barcelona</option>
                        <option value="valencia">Valencia</option>
              </select>

              <input
                  id='fecha'
                  name='fecha'
                  placeholder="fecha"
                  value={searchData.fecha}
                  onChange={(e)=>onChange(e)}
                  type='date'
                  className="rounded-3xl"
              />
              
              <button
                type="submit"
                className="bg-blue-green px-12 py-3 text-white rounded-3xl hover:bg-blue-green-dark"
              >
                Buscar
              </button>
              
            </form>

            <form onSubmit={(e) => onSubmit(e)} className="flex-col md:hidden rounded-3xl bg-white p-6 shadow-2xl mx-4">
              <label htmlFor="evento" className="text-gray-500">Artista, evento o recinto</label>
              <input
                  id='evento'
                  name='evento'
                  placeholder=""
                  value={searchData.evento}
                  onChange={(e)=>onChange(e)}
                  type='text'
                  className="rounded-3xl mb-4 mt-3 p-4 w-full"
              />
              <div className="flex w-full mb-5 gap-4">
                <div>
                  <label htmlFor="ciudad" className="text-gray-500">Ciudad</label>
                  <select
                      id='ciudad'
                      name='ciudad'
                      placeholder="ciudad"
                      value={searchData.ciudad}
                      onChange={(e)=>onChange(e)}
                      className="rounded-3xl mt-3"
                  >
                            <option value="">seleccionar</option>
                            <option value="madrid">Madrid</option>
                            <option value="barcelona">Barcelona</option>
                            <option value="valencia">Valencia</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="fecha" className="text-gray-500">Fecha</label>
                  <input
                      id='fecha'
                      name='fecha'
                      placeholder="Fecha"
                      value={searchData.fecha}
                      onChange={(e)=>onChange(e)}
                      type='date'
                      className="rounded-3xl mt-3"
                  />
                </div>
              </div>
              
              
              <button
                type="submit"
                className="bg-blue-green px-12 text-2xl py-3 text-white rounded-3xl hover:bg-blue-green-dark w-full"
              >
                Buscar
              </button>
              
            </form>
          </div>
        </div>
    )
}

export default Header